// Central CZ / EN dictionaries for all public UI text.
// Keys are resolved via t("dot.path") from LanguageContext.

export const translations = {
  cz: {
    meta: {
      title: "DRIFTEX | Filip Vimpel — Profesionální drift jezdec",
    },
    nav: {
      home: "Domů",
      about: "O mně",
      workshop: "Dílna",
      partnership: "Spolupráce",
      races: "Závody",
      media: "Media",
      shop: "Shop",
      contact: "Kontakt",
      openCart: "Otevřít košík",
    },
    marquee: {
      a: ["ZÁVODY", "TANDEMY", "EXHIBICE", "TRACKDAYS", "CONTENT"],
      b: ["FILIP VIMPEL", "E46 SUPERCHARGED", "460 HP", "JAGUAR AJ34s V8 ENGINE"],
    },
    footer: {
      desc: "Filip Vimpel — profesionální drift jezdec, tvůrce obsahu a zakázková motorsport dílna. Kouř, grip a fabrikace bez kompromisů.",
      sections: "Sekce",
      quickContact: "Rychlý kontakt",
      location: "Motorsport dílna — Ostrava-Hrabová, CZ",
      writeMe: "Napiš mi",
      links: { about: "O mně", workshop: "Motorsport dílna", partnership: "Spolupráce", races: "Závody" },
      rights: "Všechna práva vyhrazena.",
    },
    cart: {
      cart: "Košík",
      order: "Objednávka",
      done: "Hotovo",
      empty: "Košík je prázdný.",
      emptyHint: "Hoď tam nějaký merch.",
      size: "Velikost",
      remove: "Odebrat",
      minus: "Ubrat",
      plus: "Přidat",
      total: "Celkem",
      checkout: "Pokračovat k objednávce",
      back: "Zpět do košíku",
      phName: "Jméno a příjmení *",
      phEmail: "E-mail *",
      phPhone: "Telefon",
      phStreet: "Ulice a číslo popisné *",
      phCity: "Město *",
      phZip: "PSČ *",
      phNote: "Poznámka k objednávce",
      itemsCount: "položek",
      submit: "Odeslat objednávku",
      sending: "Odesílám…",
      paymentNote: "Platba a doprava se řeší individuálně e-mailem.",
      accepted: "Objednávka přijata",
      orderNumber: "Číslo objednávky:",
      thanks: "Díky za podporu! Ozvu se ti na e-mail s platbou a dopravou. Smoke everyday.",
      close: "Zavřít",
      errRequired: "Vyplň prosím všechna povinná pole.",
      errSubmit: "Objednávku se nepodařilo odeslat. Zkus to znovu.",
      success: "Objednávka odeslána!",
    },
    home: {
      heroTag: "DRIFTEX × #606",
      heroSubtitle: ["Profesionální drift jezdec", "Tvůrce obsahu", "Zakázková motorsport dílna"],
      cta: {
        partnershipTitle: "Spolupráce",
        partnershipSub: "Obsah na míru, spolupráce, pomůžu Vám jít vidět.",
        merchTitle: "Merch",
        merchSub: "Podpořte mě nákupem kvalitního merche.",
        workshopTitle: "Motorsport Dílna",
        workshopSub: "Stavby nejen drift projektů, řešení na míru, servis.",
      },
      aboutKicker: "Kdo já jsem",
      aboutTitle: "Bokem od 18",
      bio: "Jsem Filipem Vimpel driftuju profesionálně už od roku 2015, ovšem neprofesionálně jsem to už zkoušel od 18. Vystihuje mě závodní číslo 606, pod kterým jezdím od začátku mé závodní kariéry. Točim obsah ze zákulisí drift scény a ve vlastní dílně tvořím různé custom úpravy pro širokou škálu vozidel.",
      stats: [
        { value: "460+", label: "koní pod kapotou" },
        { value: "660nm", label: "kroutivý moment" },
        { value: "#606", label: "Startovní oblíbené číslo" },
        { value: "Jaguar AJ34s", label: "supercharged engine" },
        { value: "400+", label: "gum ročně" },
      ],
      raceStreets: "Race the Streets",
      fullStory: "Celý příběh",
      quote: "Mým cílem je dostat se co nejblíž nejvyšší možné úrovni driftu a vybudovat kolem toho",
      quoteAccent: " silný, profesionální projekt.",
      racesKicker: "Kalendář",
      racesTitle: "Kde mě uvidíš",
      racesLink: "Celý kalendář",
      merchKicker: "Merch drop",
      merchTitle: "Nahlédni do E-Shopu",
      merchLink: "Celý shop",
      mediaKicker: "Fotky z akcí",
      mediaTitle: "Galerie, Koukni na fotky",
      mediaLink: "Všechna media",
      galleryAlt: "DRIFTEX galerie",
    },
    about: {
      kicker: "O mně",
      titlePrefix: "Příběh ",
      story: [
        {
          kicker: "Začátky",
          title: "Z parkoviště na závodní trať",
          text: "První hodiny bokem jsem najezdil na opuštěných parkovíštích v zimě. Žádný rozpočet, jen škoda 120 a tuny odhodlání. Během let jsem přesedlal ke BMW E30 s motorizací 2.5l kterou jsem později naboural, přišla na řadu další E30, se kterou jsem se začal pomalu posouvat dále.",
        },
        {
          kicker: "Stroj",
          title: "BMW E46 - 660nm čistého kroutícího momentu",
          text: "Kompresorem poháněný V8 motor z Jaguáru s manualní převodovkou, custom lock kit připraven na extremní úhly, klec s homologací. Celé auto vzniklo v mé dílně - od holé karoserie po finální setup.",
        },
        {
          kicker: "Mise",
          title: "Obsah, který o něčem je",
          text: "Kromě závodění točím ze zakulisí drift scény a všeobecně vše kolem mého života plného adrenalinu. Stavby, testy, crashe a vítěství. Žádny fake, jen reálný motorsport, tak jak ho žiju každý den.",
        },
      ],
      trophiesKicker: "Trofeje",
      trophiesTitle: "Úspěchy",
    },
    workshop: {
      kicker: "Zakázková výroba",
      title1: "Motorsport",
      title2: "dílna",
      intro: "Věnuji se úpravám vozidel od A do Z – od stavby závodních speciálů přes zakázkovou výrobu custom dílů a výfukových systémů až po kompletní běžný servis. Ať už jde o projekt na okruh, nebo o výměnu oleje na vašem civilním autě, ke každému vozu přistupuji s maximální pečlivostí a vášní pro detail.",
      photoStrip: "Servis přímo na závodech — paddock support",
      servicesKicker: "Co děláme",
      servicesTitle: "Služby dílny",
      formKicker: "Poptávka",
      formTitle: "Rozjedeme tvůj projekt",
      formIntro: "Napiš mi, co chceš stavět. Čím víc detailů, tím přesnější odhad dostaneš. Odpovídám do 48 hodin.",
      bullets: ["Nezávazná konzultace zdarma", "Transparentní rozpočet po položkách", "Termíny, které držíme"],
      projectTypes: ["Stavba driftu na klíč", "Příprava podvozku", "Klec & fabrikace", "Motor swap & ladění", "Trackday servis", "Jiné"],
      budgets: ["do 100 000 Kč", "100 000 – 300 000 Kč", "300 000 – 600 000 Kč", "600 000+ Kč", "Zatím nevím"],
      phName: "Jméno a příjmení *",
      phEmail: "E-mail *",
      phPhone: "Telefon",
      phCar: "Model auta (např. BMW E46 330i) *",
      phProjectType: "Typ projektu *",
      phBudget: "Rozpočet *",
      phOther: "Upřesni typ projektu *",
      phDetails: "Popis projektu — co chceš postavit, v jakém stavu je auto, deadline… *",
      submit: "Poslat poptávku",
      sending: "Odesílám…",
      successTitle: "Poptávka přijata",
      successText: "Díky! Projdu si detaily a ozvu se ti do 48 hodin s prvním odhadem.",
      sendAnother: "Odeslat další",
      errRequired: "Vyplň prosím všechna povinná pole.",
      errSubmit: "Poptávku se nepodařilo odeslat. Zkus to znovu.",
      success: "Poptávka odeslána! Ozvu se do 48 hodin.",
      stripAlt: "Dílna v paddocku",
    },
    partnership: {
      kicker: "Pro značky",
      title1: "Spolu",
      title2: "práce",
      intro: "Drift je nejrychleji rostoucí motorsport pro mladé publikum. Spoj svou značku s adrenalinem, kouřem a komunitou, která žije autáma.",
      reach: [
        { value: "100K+", label: "zhlédnutí měsíčně" },
        { value: "20K+", label: "followerů napříč sítěmi" },
        { value: "20+", label: "eventů ročně" },
        { value: "120+", label: "kontentu ročně" },
      ],
      offersKicker: "Co nabízím",
      offersTitle: "Hodnota pro značku",
      offers: [
        { title: "Logo na autě", text: "Tvá značka na 620koněové E46, která je v centru pozornosti na každém eventu — na trati i na fotkách." },
        { title: "Obsah na míru", text: "Produktová videa, reels a spoty natočené kolem drift lifestyle. Nativní obsah, který mladé publikum reálně sleduje." },
        { title: "Event aktivace", text: "Stánek, exhibiční jízdy, spolujízdy pro zákazníky nebo firemní akce. Adrenalin jako zážitek pro tvou značku." },
      ],
      tiersKicker: "Balíčky",
      tiersTitle: "Úrovně partnerství",
      mostCommon: "Nejčastější",
      tiers: [
        { name: "Partner", perks: ["Logo na voze (menší plocha)", "Zmínky v obsahu", "Fotky z eventů pro marketing"] },
        { name: "Hlavní partner", perks: ["Výrazné logo na voze", "Dedikovaná videa & reels", "Event aktivace 2× ročně", "Produktové umeístění v obsahu"] },
        { name: "Titulární partner", perks: ["Jméno v názvu týmu", "Dominantní livery", "Exkluzivita v segmentu", "Kompletní obsahový balíček", "VIP zázemí na závodech"] },
      ],
      formKicker: "První krok",
      formTitle: "Chci spolupráci",
      types: ["Sponzoring týmu", "Obsah na míru", "Event / exhibice", "Produktová spolupráce", "Jiné"],
      budgets: ["do 50 000 Kč", "50 000 – 200 000 Kč", "200 000 – 500 000 Kč", "500 000+ Kč", "Zatím nevím"],
      phCompany: "Firma / značka *",
      phContact: "Kontaktní osoba *",
      phEmail: "E-mail *",
      phType: "Typ spolupráce *",
      phBudget: "Orientační rozpočet (nepovinné)",
      phMessage: "Popiš svou představu spolupráce *",
      submit: "Chci spolupráci",
      sending: "Odesílám…",
      successTitle: "Nabídka přijata",
      successText: "Díky za zájem! Ozvu se ti s konkrétním návrhem spolupráce.",
      sendAnother: "Odeslat další",
      errRequired: "Vyplň prosím všechna povinná pole.",
      errSubmit: "Nepodařilo se odeslat. Zkus to znovu.",
      success: "Nabídka odeslána! Ozvu se co nejdřív.",
    },
    races: {
      kicker: "Kalendář & výsledky",
      title: "Závody",
      season: "Sezóna",
      upcoming: "Nadcházející",
      empty: "V této sezóně zatím nejsou žádné závody.",
    },
    media: {
      kicker: "Galerie & obsah",
      title: "Media",
      videosTitle: "Nejnovější videa",
      channel: "Kanál",
      videosError: "Videa se nepodařilo načíst. Mrkni přímo na kanál.",
      openYoutube: "Otevřít YouTube",
      olderVideos: "STARŠÍ VIDEA NA YOUTUBE",
      galleryKicker: "Galerie",
      galleryTitle: "Fotky z akcí",
      galleryEmpty: "Galerie je zatím prázdná.",
      followKicker: "Sleduj",
      followTitle: "Kde jede obsah",
      platforms: {
        youtube: "Stavby, vlogy ze závodů a POV jízdy",
        instagram: "Denní dávka kouře a zákulisí",
        tiktok: "Virální drift momenty",
      },
      prev: "Předchozí",
      next: "Další",
      close: "Zavřít",
      closeVideo: "Zavřít video",
      galleryFallback: "Galerie",
    },
    shop: {
      kicker: "Merch drop",
      title: "Shop",
      intro: "Oblečení a samolepky přímo od týmu. Každý kus podporuje další sezónu.",
      catAll: "Vše",
      catClothing: "Oblečení",
      catStickers: "Samolepky",
      sizePh: "Vel.",
      addToCart: "Do košíku",
      empty: "V této kategorii zatím nic není.",
      sizeFirst: "Vyber nejdřív velikost.",
      added: "přidáno do košíku",
      cartAction: "Košík",
    },
    contact: {
      kicker: "Spojme se",
      title: "Kontakt",
      infoKicker: "Kde mě najdeš",
      infoTitle: "Ozvi se",
      labelEmail: "E-mail",
      labelPhone: "Telefon",
      labelWorkshop: "Dílna",
      workshopValue: "Ostrava-Hrabová, Česká republika",
      phName: "Jméno *",
      phEmail: "E-mail *",
      phMessage: "Tvoje zpráva *",
      submit: "Odeslat zprávu",
      sending: "Odesílám…",
      successTitle: "Zpráva odeslána",
      successText: "Díky! Odpovím co nejdřív, většinou do 24 hodin.",
      sendAnother: "Napsat další",
      errRequired: "Vyplň prosím všechna pole.",
      errSubmit: "Zprávu se nepodařilo odeslat. Zkus to znovu.",
      success: "Zpráva odeslána!",
    },
  },

  en: {
    meta: {
      title: "DRIFTEX | Filip Vimpel — Professional Drift Driver",
    },
    nav: {
      home: "Home",
      about: "About",
      workshop: "Workshop",
      partnership: "Partnership",
      races: "Races",
      media: "Media",
      shop: "Shop",
      contact: "Contact",
      openCart: "Open cart",
    },
    marquee: {
      a: ["RACES", "TANDEMS", "EXHIBITIONS", "TRACKDAYS", "CONTENT"],
      b: ["FILIP VIMPEL", "E46 SUPERCHARGED", "460 HP", "JAGUAR AJ34s V8 ENGINE"],
    },
    footer: {
      desc: "Filip Vimpel — professional drift driver, content creator and custom motorsport workshop. Smoke, grip and fabrication without compromise.",
      sections: "Sections",
      quickContact: "Quick contact",
      location: "Motorsport workshop — Ostrava-Hrabová, CZ",
      writeMe: "Message me",
      links: { about: "About me", workshop: "Motorsport workshop", partnership: "Partnership", races: "Races" },
      rights: "All rights reserved.",
    },
    cart: {
      cart: "Cart",
      order: "Checkout",
      done: "Done",
      empty: "Your cart is empty.",
      emptyHint: "Throw some merch in.",
      size: "Size",
      remove: "Remove",
      minus: "Decrease",
      plus: "Increase",
      total: "Total",
      checkout: "Proceed to checkout",
      back: "Back to cart",
      phName: "Full name *",
      phEmail: "E-mail *",
      phPhone: "Phone",
      phStreet: "Street and house number *",
      phCity: "City *",
      phZip: "ZIP code *",
      phNote: "Order note",
      itemsCount: "items",
      submit: "Place order",
      sending: "Sending…",
      paymentNote: "Payment and shipping are arranged individually by e-mail.",
      accepted: "Order received",
      orderNumber: "Order number:",
      thanks: "Thanks for the support! I'll e-mail you about payment and shipping. Smoke everyday.",
      close: "Close",
      errRequired: "Please fill in all required fields.",
      errSubmit: "Failed to place the order. Please try again.",
      success: "Order placed!",
    },
    home: {
      heroTag: "DRIFTEX × #606",
      heroSubtitle: ["Professional drift driver", "Content creator", "Custom motorsport workshop"],
      cta: {
        partnershipTitle: "Partnership",
        partnershipSub: "Custom content and partnerships — I'll get your brand seen.",
        merchTitle: "Merch",
        merchSub: "Support me by grabbing quality merch.",
        workshopTitle: "Motorsport Workshop",
        workshopSub: "Builds beyond drift projects, custom solutions, servicing.",
      },
      aboutKicker: "Who I am",
      aboutTitle: "Sideways since 18",
      bio: "I'm Filip Vimpel and I've been drifting professionally since 2015 — though I first tried it at 18. I'm defined by race number 606, which I've carried since the start of my racing career. I film behind-the-scenes content from the drift scene and build custom modifications for a wide range of cars in my own workshop.",
      stats: [
        { value: "460+", label: "horsepower under the hood" },
        { value: "660nm", label: "of torque" },
        { value: "#606", label: "favourite race number" },
        { value: "Jaguar AJ34s", label: "supercharged engine" },
        { value: "400+", label: "tires a year" },
      ],
      raceStreets: "Race the Streets",
      fullStory: "Full story",
      quote: "My goal is to get as close as possible to the highest level of drifting and build",
      quoteAccent: " a strong, professional project around it.",
      racesKicker: "Calendar",
      racesTitle: "Where you'll see me",
      racesLink: "Full calendar",
      merchKicker: "Merch drop",
      merchTitle: "Check out the E-Shop",
      merchLink: "Full shop",
      mediaKicker: "Event photos",
      mediaTitle: "Gallery, check the photos",
      mediaLink: "All media",
      galleryAlt: "DRIFTEX gallery",
    },
    about: {
      kicker: "About me",
      titlePrefix: "The Story of ",
      story: [
        {
          kicker: "Beginnings",
          title: "From a parking lot to the race track",
          text: "I clocked my first sideways hours on abandoned parking lots in winter. No budget, just a Škoda 120 and tons of determination. Over the years I moved to a BMW E30 with a 2.5l engine, which I later crashed — then came another E30, with which I slowly started pushing forward.",
        },
        {
          kicker: "The machine",
          title: "BMW E46 - 660nm of pure torque",
          text: "A supercharged Jaguar V8 with a manual gearbox, a custom lock kit ready for extreme angles, and a homologated roll cage. The whole car was born in my workshop — from a bare shell to the final setup.",
        },
        {
          kicker: "The mission",
          title: "Content that actually means something",
          text: "Besides racing, I film behind the scenes of the drift world and everything around my adrenaline-filled life. Builds, tests, crashes and victories. No fake — just real motorsport, the way I live it every day.",
        },
      ],
      trophiesKicker: "Trophies",
      trophiesTitle: "Achievements",
    },
    workshop: {
      kicker: "Custom fabrication",
      title1: "Motorsport",
      title2: "workshop",
      intro: "I work on cars from A to Z — from building race specials, through custom parts and exhaust fabrication, all the way to complete routine servicing. Whether it's a track project or an oil change on your daily, I approach every car with maximum care and a passion for detail.",
      photoStrip: "Race-day servicing — paddock support",
      servicesKicker: "What we do",
      servicesTitle: "Workshop services",
      formKicker: "Inquiry",
      formTitle: "Let's start your project",
      formIntro: "Tell me what you want to build. The more detail, the more accurate the estimate. I reply within 48 hours.",
      bullets: ["Free no-obligation consultation", "Transparent itemised budget", "Deadlines we actually keep"],
      projectTypes: ["Turnkey drift build", "Suspension setup", "Roll cage & fabrication", "Engine swap & tuning", "Trackday service", "Other"],
      budgets: ["up to 100 000 CZK", "100 000 – 300 000 CZK", "300 000 – 600 000 CZK", "600 000+ CZK", "Not sure yet"],
      phName: "Full name *",
      phEmail: "E-mail *",
      phPhone: "Phone",
      phCar: "Car model (e.g. BMW E46 330i) *",
      phProjectType: "Project type *",
      phBudget: "Budget *",
      phOther: "Specify your project type *",
      phDetails: "Project description — what you want to build, the car's condition, deadline… *",
      submit: "Send inquiry",
      sending: "Sending…",
      successTitle: "Inquiry received",
      successText: "Thanks! I'll go through the details and get back to you within 48 hours with a first estimate.",
      sendAnother: "Send another",
      errRequired: "Please fill in all required fields.",
      errSubmit: "Failed to send the inquiry. Please try again.",
      success: "Inquiry sent! I'll get back to you within 48 hours.",
      stripAlt: "Workshop in the paddock",
    },
    partnership: {
      kicker: "For brands",
      title1: "Partner",
      title2: "ship",
      intro: "Drifting is the fastest-growing motorsport among young audiences. Connect your brand with adrenaline, smoke and a community that lives for cars.",
      reach: [
        { value: "100K+", label: "views per month" },
        { value: "20K+", label: "followers across platforms" },
        { value: "20+", label: "events per year" },
        { value: "120+", label: "pieces of content per year" },
      ],
      offersKicker: "What I offer",
      offersTitle: "Value for your brand",
      offers: [
        { title: "Logo on the car", text: "Your brand on a 620hp E46 that's the centre of attention at every event — on track and in photos." },
        { title: "Custom content", text: "Product videos, reels and spots shot around the drift lifestyle. Native content that young audiences actually watch." },
        { title: "Event activation", text: "A booth, exhibition runs, ride-alongs for customers or corporate events. Adrenaline as an experience for your brand." },
      ],
      tiersKicker: "Packages",
      tiersTitle: "Partnership tiers",
      mostCommon: "Most popular",
      tiers: [
        { name: "Partner", perks: ["Logo on the car (smaller area)", "Mentions in content", "Event photos for your marketing"] },
        { name: "Main partner", perks: ["Prominent logo on the car", "Dedicated videos & reels", "Event activation 2× a year", "Product placement in content"] },
        { name: "Title partner", perks: ["Your name in the team name", "Dominant livery", "Segment exclusivity", "Complete content package", "VIP race-day hospitality"] },
      ],
      formKicker: "First step",
      formTitle: "I want to partner",
      types: ["Team sponsorship", "Custom content", "Event / exhibition", "Product partnership", "Other"],
      budgets: ["up to 50 000 CZK", "50 000 – 200 000 CZK", "200 000 – 500 000 CZK", "500 000+ CZK", "Not sure yet"],
      phCompany: "Company / brand *",
      phContact: "Contact person *",
      phEmail: "E-mail *",
      phType: "Partnership type *",
      phBudget: "Approximate budget (optional)",
      phMessage: "Describe your partnership idea *",
      submit: "I want to partner",
      sending: "Sending…",
      successTitle: "Offer received",
      successText: "Thanks for your interest! I'll get back to you with a concrete partnership proposal.",
      sendAnother: "Send another",
      errRequired: "Please fill in all required fields.",
      errSubmit: "Failed to send. Please try again.",
      success: "Offer sent! I'll get back to you as soon as possible.",
    },
    races: {
      kicker: "Calendar & results",
      title: "Races",
      season: "Season",
      upcoming: "Upcoming",
      empty: "No races in this season yet.",
    },
    media: {
      kicker: "Gallery & content",
      title: "Media",
      videosTitle: "Latest videos",
      channel: "Channel",
      videosError: "Couldn't load videos. Check the channel directly.",
      openYoutube: "Open YouTube",
      olderVideos: "OLDER VIDEOS ON YOUTUBE",
      galleryKicker: "Gallery",
      galleryTitle: "Event photos",
      galleryEmpty: "The gallery is empty for now.",
      followKicker: "Follow",
      followTitle: "Where the content lives",
      platforms: {
        youtube: "Builds, race vlogs and POV drives",
        instagram: "Daily dose of smoke and behind the scenes",
        tiktok: "Viral drift moments",
      },
      prev: "Previous",
      next: "Next",
      close: "Close",
      closeVideo: "Close video",
      galleryFallback: "Gallery",
    },
    shop: {
      kicker: "Merch drop",
      title: "Shop",
      intro: "Clothing and stickers straight from the team. Every piece supports the next season.",
      catAll: "All",
      catClothing: "Clothing",
      catStickers: "Stickers",
      sizePh: "Size",
      addToCart: "Add to cart",
      empty: "Nothing in this category yet.",
      sizeFirst: "Pick a size first.",
      added: "added to cart",
      cartAction: "Cart",
    },
    contact: {
      kicker: "Let's connect",
      title: "Contact",
      infoKicker: "Where to find me",
      infoTitle: "Get in touch",
      labelEmail: "E-mail",
      labelPhone: "Phone",
      labelWorkshop: "Workshop",
      workshopValue: "Ostrava-Hrabová, Czech Republic",
      phName: "Name *",
      phEmail: "E-mail *",
      phMessage: "Your message *",
      submit: "Send message",
      sending: "Sending…",
      successTitle: "Message sent",
      successText: "Thanks! I'll reply as soon as possible, usually within 24 hours.",
      sendAnother: "Write another",
      errRequired: "Please fill in all fields.",
      errSubmit: "Failed to send the message. Please try again.",
      success: "Message sent!",
    },
  },
};
